<template>
  <div>
    <ul class="button-list__list" v-if="type === 'button'">
      <li class="button-list__item" v-for="item in list">
        <a class="button-list__link" :href="item.url">
          <img
            v-if="item.thumbnail"
            :src="item.thumbnail"
            :alt="item.name"
            class="button-list__img"
          />
          <em>{{ item.name }}</em>
        </a>
      </li>
    </ul>
    <ul class="link-list" v-else>
      <li class="link-list__item" v-for="item in list">
        <a class="link-list__link" :href="item.url" v-html="item._highlightResult ? item._highlightResult.name.value : item.name">
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  name: "LinkList",
  props: ["list", "type", "searchTerm"],
  methods: {}
});
</script>
